import { ACC_KEY, POWERLEGO_API_URL } from "../config";

export const saveEnrollment = async (enrollmentId, restFields, sign) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  if (enrollmentId) formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);
  for (let i in restFields) {
    formdata.append(i, restFields[i]);
  }

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/save`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const getEnrollmentRecord = async (enrollmentId, sign) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/retrieve`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const confirmEnrollment = async (
  enrollmentId,
  specialPro,
  sign,
  utmContent
) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);
  if (utmContent) formdata.append("utm_content", utmContent);
  formdata.append("api_action", "save");
  for (const key in specialPro) {
    if (specialPro[key]) formdata.append(key, specialPro[key]);
  }

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/submit`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const confirmEnrollmentAfterDeposit = async (
  enrollmentId,
  sign,
) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("enrollment_id", enrollmentId);
  if (sign) formdata.append("sign", sign);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/confirm`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

export const getEnrollmentInputs = async (providerId, esiid) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("provider_id", providerId);
  formdata.append("esiid", esiid);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/input`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

//TODO
export const saveEnrollmentPaymentInfo = async (recordId, paymentResponse) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("record_identifier", recordId);
  formdata.append("payment_response", paymentResponse);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/payment`;

  const response = await fetch(url, requestOptions);
  return response.json();
};

//TODO
export const getBlackoutDate = async (
  product,
  zipcode,
  utility_code,
  esiid,
  serviceType
) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${ACC_KEY}`);

  const formdata = new FormData();
  formdata.append("product", product);
  formdata.append("zipcode", zipcode);
  formdata.append("utility_code", utility_code);
  formdata.append("esiid", esiid);
  formdata.append("service_type", serviceType);
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const url = `${POWERLEGO_API_URL}/v2/constellation/blackout_date`;

  const response = await fetch(url, requestOptions);
  return response.json();
};
